/**
 * Browser logging: REACT_APP_LOG_LEVEL = silent | error | warn | info | debug (default: info)
 * Use debug() for development-only diagnostics; keep info/warn/error for user-visible issues.
 */

const LEVELS = { silent: 0, error: 1, warn: 2, info: 3, debug: 4 };

function resolveLevel() {
  const v = (process.env.REACT_APP_LOG_LEVEL || '').trim().toLowerCase();
  if (v === 'silent' || v === 'error' || v === 'warn' || v === 'info' || v === 'debug') {
    return v;
  }
  return 'info';
}

const currentLevel = resolveLevel();
const order = LEVELS[currentLevel];

function allow(levelName) {
  if (currentLevel === 'silent') return false;
  return LEVELS[levelName] <= order;
}

export const logger = {
  level: currentLevel,
  error: (...args) => {
    if (allow('error')) console.error(...args);
  },
  warn: (...args) => {
    if (allow('warn')) console.warn(...args);
  },
  info: (...args) => {
    if (allow('info')) console.log(...args);
  },
  debug: (...args) => {
    if (allow('debug')) console.log(...args);
  },
};

export default logger;
